// extracted by mini-css-extract-plugin
module.exports = {"root":"FiltersSearch_root__YVyFZ","form":"FiltersSearch_form__ubUUL","clearButton":"FiltersSearch_clearButton__hBbL2","searchButton":"FiltersSearch_searchButton__dkHRx"};